import React, { useEffect } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store, { persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProviderWrapper } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import { SupportChatNotificationProvider } from './context/SupportChatNotificationContext';
import AppRoutes from './routes';
import { getCurrentUser, forceLogout } from './store/slices/authSlice';

function AppContent() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const token = useSelector(state => state.auth.token);

  useEffect(() => {
    if (token) {
      dispatch(getCurrentUser());
    }
  }, [token, dispatch]);

  useEffect(() => {
    const handleAuthLogout = () => {
      dispatch(forceLogout());
    };

    window.addEventListener('auth:logout', handleAuthLogout);
    return () => {
      window.removeEventListener('auth:logout', handleAuthLogout);
    };
  }, [dispatch]);

  return (
    <ThemeProviderWrapper>
      <NotificationProvider>
        <SupportChatNotificationProvider>
          <Router>
            <AppRoutes />
          </Router>
        </SupportChatNotificationProvider>
      </NotificationProvider>
    </ThemeProviderWrapper>
  );
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppContent />
      </PersistGate>
    </Provider>
  );
}

export default App;
